import React from 'react';
import clsx from 'clsx';
import Paper, { type PaperProps } from '@mui/material/Paper';

import { FlexColumn } from 'src/components/flex';

import styles from 'src/components/page/PageSection.module.css';

interface Props extends PaperProps {
    /**
     * If true, the section will have a transparent background.
     */
    transparent?: boolean,
    /**
     * If true, the section will have no padding.
     */
    withoutPadding?: boolean,
    /**
     * If true, the section will have no padding on desktop.
     */
    desktopWithoutPadding?: boolean,
    children: React.ReactNode
}

/**
 * Section of a page.
 * Used to separate content in a page.
 */
const PageSection: React.FC<Props> = ({
    className,
    transparent,
    withoutPadding,
    desktopWithoutPadding,
    children,
    ...paperProps
}) => {

    return (
        <Paper
            className={clsx(
                styles.root,
                transparent && styles.transparent,
                className
            )}
            {...paperProps}
        >
            <FlexColumn p={2} className={clsx(
                withoutPadding && styles.withoutPadding,
                desktopWithoutPadding && styles.desktopWithoutPadding
            )}
            >
                {children}
            </FlexColumn>
        </Paper>
    );
};

export default PageSection;